import MenuModel from "./menuModel.js";
import {TYPE_SECTION_MODEL} from "../utils/enums.js";
import { currentUserIsSupervisorRole } from '../services/userModel.js';

export function createMenuCouriermanagementSettings() {
    return [
        new MenuModel({
            pathname: TYPE_SECTION_MODEL.courierDeliveryFees,
            title: "settings.courierDeliveryFeesSettings.LABEL",
            isShow: () => currentUserIsSupervisorRole(),
            active: location => getIsActive(location, TYPE_SECTION_MODEL.courierDeliveryFees)
        }),
        new MenuModel({
            pathname: TYPE_SECTION_MODEL.courierDeliveryFeesTemplate,
            isShow: () => currentUserIsSupervisorRole(),
            title: "settings.courierDeliveryFeesSettings.TEMPLATE_LABEL",
            active: location => getIsActive(location, TYPE_SECTION_MODEL.courierDeliveryFeesTemplate)
        }),
        new MenuModel({
            pathname: TYPE_SECTION_MODEL.courierAppSettings,
            title: "settings.courierSettings.LABEL",
            active: location => getIsActive(location, TYPE_SECTION_MODEL.courierAppSettings)
        }),
    ]
}

function getIsActive(location, type) {
    const splitCurrentLocation = location.pathname.split('/');
    const splitType = type.split('/');
    return (
        splitCurrentLocation[1] === splitType[1] &&
        splitCurrentLocation[2] === splitType[2] &&
        splitCurrentLocation[3] === splitType[3]
    );
}
